import styled from "styled-components";

import { ConsolePageButtonStyles } from "@Console/components/molecules/ConsolePageForm/atoms/ConsolePageButton/styles";

export const CustomButtonRedirect = styled(ConsolePageButtonStyles)`
  background-color: ${({ theme }) => theme.colors.primary} !important;
  color: ${({ theme }) => theme.colors.textMasterColor} !important;

  :hover {
    background-color: ${({ theme }) => theme.colors.secondary} !important;
  }
`;
